import React from 'react';
import { motion } from 'framer-motion';
import { Video, BookOpen, List } from 'lucide-react';
export function OldSolutionsFail() {
  const solutions = [{
    icon: <Video className="h-8 w-8 text-gold" data-id="element-200" />,
    title: 'Vídeos sueltos',
    problem: 'Te dejan hype. No te dejan un sistema.'
  }, {
    icon: <BookOpen className="h-8 w-8 text-gold" data-id="element-201" />,
    title: 'Guías clásicas',
    problem: "Te dicen qué visitar. No te resuelven el 'cómo funciona el día a día' (apps, pagos, conectividad)."
  }, {
    icon: <List className="h-8 w-8 text-gold" data-id="element-202" />,
    title: 'Itinerarios copiados',
    problem: 'Te dan una lista. No te dan ritmo, ni plan B, ni cómo encajar ciudades sin convertirte en un transportista.'
  }];
  return <section className="py-10 lg:py-20 px-4 sm:px-6 lg:px-8 bg-charcoal text-white" data-id="element-203">
      <div className="max-w-6xl mx-auto" data-id="element-204">
        <div className="text-center mb-8 lg:mb-16" data-id="element-205">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 lg:mb-6" data-id="element-206">
            Por qué lo que has visto no te sirve
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-207"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-8" data-id="element-208">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-charcoal-light/30 p-5 lg:p-8 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-209">
              <div className="mb-4 lg:mb-6 inline-block p-3 lg:p-4 bg-white/5 rounded-full border border-white/10" data-id="element-210">
                {item.icon}
              </div>
              <h3 className="text-lg lg:text-xl font-bold text-white mb-2 lg:mb-4 font-serif" data-id="element-211">
                {index + 1}) {item.title}
              </h3>
              <p className="text-gray-300 leading-relaxed text-sm lg:text-base" data-id="element-212">
                {item.problem}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}